if($('.type-detail').length){
    $('.p-info-wrapper').append('<div class="ship-row"></div>')
    $('.ship-row').append($('.availability-value'), $('.shipping-options'))
    $('.p-detail-info').append($('.p-detail-inner-header .p-code'))
    if($('.p-info-wrapper .detail-parameters .variant-list').length>0){
        $('.p-info-wrapper').addClass('have-multiple-var')
    }
    $('.extended-description .detail-parameters tr td').each(function(){
        $(this).html(function(){
            return $(this).html().replace(/,/g, "<br>");
          })
    })
    if($('.p-detail-info .flags-default').length){
        $('.p-image-wrapper .p-image').append($('.p-detail-info .flags-default'))
    }
    
    
      
    $(document).ready(function () {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: '/cache/dopravy-a-platby/doprava-'+$('a[href*="/znacka/"]').attr('href').split('/znacka/')[1],
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find('.news-item-detail .text').html();
                $('<li class="shp-tab"><a class="shp-tab-link" href="#doprava-a-platba" data-toggle="tab">Doprava a platba</a></li>').appendTo(".p-detail-tabs");
                $('#tab-content').append('<div class="tab-pane fade" id="doprava-a-platba" role="tabpanel"></div>')
                null !== t && ($("#doprava-a-platba").html(t))
                $('a.shipping-options').replaceWith('<span class="shipping-options newShipping">Možnosti dopravy</span>')
                $(document).on('click', '.newShipping', function(){
                    $.colorbox({
                        html: '<div class="newShippingFormInner"><h2>Doprava a platba</h2>'+t+'</div>',
                        width: 800,
                        maxWidth: "95%",
                        height: 500,
                        maxHeight: "95%",
                        className: "newShippingForm",
                        onComplete: function() {
                            
                        }
                    })
                })
                }
            });
            
        
    })

 
    $(document).ready(function(){
        setTimeout(function(){
    var htmlLista = '<div class="detail-lista">'
        htmlLista += '<div class="container">'
            htmlLista += '<div class="left">'
                htmlLista += '<ul>'
                //Popis | Parametry | Doprava a Platba
                if($('#p-detail-tabs li[data-testid="tabDescription"]').length){
                    htmlLista += '<li><a href="#description" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Popis</a></li>'
                }
                if($('#p-detail-tabs li a[href="#extended-description"]').length){
                    htmlLista += '<li><a href="#extended-description" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Parametry</a></li>'
                }
                if($('#p-detail-tabs li a[href="#relatedFiles"]').length){
                    htmlLista += '<li><a href="#relatedFiles" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Ke stažení</a></li>'
                }
                if($('#p-detail-tabs li a[href="#productVideos"]').length){
                    htmlLista += '<li><a href="#productVideos" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Videa</a></li>'
                }
                if($('#p-detail-tabs li a[href="#doprava-a-platba"]').length){
                    htmlLista += '<li><a href="#doprava-a-platba" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Doprava a platba</a></li>'
                }
                if($('#relProd').length){
                    htmlLista += '<li><a href="#relProd" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Související zboží</a></li>'
                }
                htmlLista += '</ul>'
            htmlLista += '</div>'
            htmlLista += '<div class="right">'
                htmlLista += '<div class="image">'
                    htmlLista += '<img src="'+$('.p-image a').attr('href').replace('/big/', '/detail/')+'">'
                htmlLista += '</div>'
                htmlLista += '<div class="price-row">'
                    htmlLista += '<span class="title">'+$('.p-detail-inner-header h1').text()+'</span>'
                    if($('.konfig').length){
                        htmlLista += '<span class="price">'+Number(Math.round(cenazabaleni*obshabaleni)).ShoptetFormatAsCurrency()+' <span class="pr-list-unit"> / '+cenaV+'</span></span>'
                    }
                    else{
                        htmlLista += '<span class="price">'+$('.p-info-wrapper .price-final-holder').html()+'</span>'
                    }
                   
                    if($('.variant-list').length){
                        htmlLista += '<span class="avalability">'+$('.p-info-wrapper .availability-value').html()+'</span>'
                    }
                    else{
                        htmlLista += '<span class="avalability" style="'+$('.p-info-wrapper .availability-label').attr('style')+'">'+$('.p-info-wrapper .availability-value').text()+'</span>'
                    }
                htmlLista += '</div>'
                htmlLista += '<div class="buy-button" data-buy="'+$('input[name="priceId"]').attr('value')+'">'
                    htmlLista += '<span class="button">Do košíku</span>'
                htmlLista += '</div>'
            htmlLista += '</div>'
        htmlLista += '</div>'
    htmlLista += '</div>'
    $('body').append(htmlLista)
    
    }, 550)
        
    })
  
    
    document.addEventListener('ShoptetVariantAvailable', function() {

    	$('.detail-lista .right .avalability').html($('.availability-value>span:not(".no-display")').html())
	});
   
    $(document).on('click', '.detail-lista .buy-button span', function(e){
        e.preventDefault();
  //      console.log($('.p-info-wrapper .add-to-cart .quantity input').val())
        shoptet.cartShared.addToCart({priceId: $(this).closest('.buy-button').attr('data-buy'), amount:$('.p-info-wrapper .add-to-cart .quantity input').val()});
      /*  $.post('/action/Cart/addCartItem/', $('#product-detail-form').serialize()).done(function(data) {
            if(data.code = 200){
                setTimeout(function(){
                    $('header#header .cart-count').append('<i>'+data.payload.cartItems.length+'</i>')
                }, 100)
                
            }
        })*/
    })
    $(document).on('click', '.detail-lista .left ul li a', function(){
        $('#tab-content>div').removeClass('active in')
        $('#tab-content>div[id="'+$(this).attr('href').replace('#', '')+'"]').addClass('active in')
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 20
        }, 1000);
    })
    if($('.products-alternative .product').length>5){
        $('.products-alternative .product:not(":nth-child(-n+5)")').addClass('not-dipslay')
        $('.products-alternative').append('<div class="text-center"><span class="zobrazit-vice">Zobrazit více</span></div>')
    }
    $(document).on('click', '.zobrazit-vice', function(){
        $(this).toggleClass('show-more')
        $('.products-alternative .product:not(":nth-child(-n+5)")').toggleClass('not-dipslay')
        $(".zobrazit-vice").text(($(".zobrazit-vice").text() == 'Zobrazit více') ? 'Zobrazit méně' : 'Zobrazit více').fadeIn();
    })

    if($('.product-top a[data-testid="productCardBrandName"]').length){

        var nameBrandFile = $('.product-top a[data-testid="productCardBrandName"]').attr('href').split('/')[2];
        var filePath = '/user/documents/akce-znacek/' + nameBrandFile + '.txt';
        var code = $('.product-top .p-code span').not('.p-code-label').text().trim()
     //   if($('.admin-logged').length){
      //      $('header#header').after('<div class="text-center">Název souboru: '+nameBrandFile+'; Kód produktu: '+code+'</div>')
       // }
        
            $.ajax({
                url: filePath,
                dataType: 'text',
                success: function(data) {
                    var lines = data.split('\n');
                    var parsedData = lines.map(function(line) {
                        return line.split(';');
                    });
                    function parseDate(input) {
                        var parts = input.split('.');
                        return new Date(parts[2], parts[1] - 1, parts[0]);
                    }
                    function getDeclension(value, words) {
                        return value === 1 ? words[0] : (value >= 1 && value <= 4 ? words[1] : words[2]);
                    }
                    function createTimeSpan(value, word) {
                        return value + ' <span class="timeWord">' + word + '</span>';
                    }
                    function timeDifference(date1, date2) {
                        var diff = Math.abs(date2 - date1);
                        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
                        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((diff % (1000 * 60)) / 1000);
                        return {days: days, hours: hours, minutes: minutes, seconds: seconds};
                    }
                    setInterval(function() {
                        var currentDate = new Date();
                        parsedData.forEach(function(item, index) {
                            if (item[0] === code) {
                                var startDate = parseDate(item[2]);
                                var endDate = parseDate(item[3]);
                                if (currentDate >= startDate && currentDate <= endDate) {
                                    if(!$('.timeToEnd').length){
                                        $('.p-info-wrapper').append('<div class="timeToEnd"><h4>Do konce slevy <span class="saleAction">'+$('.product-top .flag-discount .price-save').text()+'</span> zbývá</h4><div class="time"></div></div>')
                                    }
                                    var remainingTime = timeDifference(currentDate, endDate);
                                    var daysWord = getDeclension(remainingTime.days, ['den', 'dny', 'dní']);
                                    var hoursWord = getDeclension(remainingTime.hours, ['hodina', 'hodiny', 'hodin']);
                                    var minutesWord = getDeclension(remainingTime.minutes, ['minuta', 'minuty', 'minut']);
                                    var secondsWord = getDeclension(remainingTime.seconds, ['sekunda', 'sekundy', 'sekund']);
                                   // $('.timeToEnd').html('<span class="days">'++' <i>dnů</i></span>')
                                   var timeHtml =   '<span>'+createTimeSpan(remainingTime.days, daysWord) + '</span>' +
                                                    '<span>'+createTimeSpan(remainingTime.hours, hoursWord) + '</span>' +
                                                    '<span>'+createTimeSpan(remainingTime.minutes, minutesWord) + '</span>' +
                                                    '<span>'+createTimeSpan(remainingTime.seconds, secondsWord)+ '</span>';
                                    $('.timeToEnd .time').html(timeHtml)
                                 
                                }
                            }
                        });
                    }, 1000); 
                    
                },
                error: function() {
                    console.error('Nemám datový soubor')
                }
            });
    }
}